/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import PropTypes from 'prop-types';
import { ChannelCellProps } from './ChannelCellProps';
import { GuideHighlight } from '../GuideHighlight';
import { ImageLoader } from '../../ImageLoader';
import { ImageLoaderTypes } from '../../ImageLoader/ImageLoaderTypes';
import { Mousetrap } from '../../common';

import './ChannelCell.scss';

const ChannelCell: FunctionComponent<ChannelCellProps> = ({
    channel,
    highlightId,
}): JSX.Element => {
    const channelObj = Object(channel);
    const { channelNumber, callSign, channelLogoUrl, videoResolution, isSubscribed } = channelObj;

    return (
        <Mousetrap value={highlightId}>
            <div className="channel-cell">
                <GuideHighlight id={highlightId}></GuideHighlight>
                <div
                    className={`channel-number ${!isSubscribed ? 'channel-fadeout' : ''} ${
                        channelNumber && channelNumber.length > 4 ? 'adjust-channel-number' : ''
                    }`}
                    data-testid="channel-number"
                >
                    {channelNumber}
                </div>
                <div
                    className={`stream-type-icon ${videoResolution}`}
                    data-testid="stream-type-icon"
                ></div>
                <div data-testid="guide-channel-branding">
                    <ImageLoader
                        src={channelLogoUrl}
                        imageType={ImageLoaderTypes.CHANNEL_BRANDING_IMAGE}
                        placeholder={callSign}
                    />
                </div>
            </div>
        </Mousetrap>
    );
};

ChannelCell.propTypes = {
    channel: PropTypes.object,
    highlightId: PropTypes.string,
};

export default ChannelCell;
